// src/components/PrivacyPolicy.js

import React from "react";
import './PrivacyPolicy.css';  // Import the CSS file for styling
import NavBar from "../NavBar/NavBar";
import RunningHeader from "../RunningHeader/RunningHeader";
import Footer from "../Footer/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      <NavBar/>
      <RunningHeader/>
 
    <div className="privacy-policy-container">
      <header className="privacy-policy-header">
        <h1>Privacy Policy for Reporters</h1>
      </header>

      <section className="privacy-policy-content"><p>
        <h2>1. Collection of Personal Information</h2>
        <p>
          Today Local News ("TLN") collects personal information from Reporters when they register on the TLN website, submit content, or communicate with TLN staff. The types of personal information collected may include:
        </p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Address</li>
          <li>Password (encrypted)</li>
          <li>Content submissions (articles, images, videos, etc.)</li>
        </ul>

        <h2>2. Use of Personal Information</h2>
        <p>
          TLN uses the personal information collected from Reporters for the following purposes:
        </p>
        <ul>
          <li>To verify the identity of Reporters and ensure the accuracy of content submissions</li>
          <li>To communicate with Reporters regarding their content submissions, assignments, and other work-related matters</li>
          <li>To provide Reporters with access to the TLN website and its features</li>
          <li>To analyze and improve the TLN website and its services</li>
          <li>To comply with applicable laws and regulations</li>
        </ul>

        <h2>3. Disclosure of Personal Information</h2>
        <p>
          TLN may disclose personal information collected from Reporters to:
        </p>
        <ul>
          <li>TLN staff and contractors who require access to the information to perform their duties</li>
          <li>Third-party service providers who assist TLN with its operations, such as website hosting and maintenance</li>
          <li>Law enforcement agencies or regulatory bodies, as required by law</li>
          <li>Other parties, with the Reporter's consent or as permitted by law</li>
        </ul>

        <h2>4. Protection of Personal Information</h2>
        <p>
          TLN takes reasonable measures to protect the personal information collected from Reporters against unauthorized access, disclosure, or destruction. These measures may include:
        </p>
        <ul>
          <li>Encryption of sensitive information, such as passwords</li>
          <li>Secure socket layer (SSL) technology to protect data transmission</li>
          <li>Firewalls and intrusion detection systems to prevent unauthorized access</li>
          <li>Regular backups and disaster recovery procedures to ensure business continuity</li>
          <li>Access controls, such as passwords and two-factor authentication, to restrict access to authorized personnel</li>
        </ul>

        <h2>5. Access and Correction of Personal Information</h2>
        <p>
          Reporters have the right to access and correct their personal information collected by TLN. To do so, Reporters may:
        </p>
        <ul>
          <li>Log in to their TLN account and update their profile information</li>
          <li>Contact TLN's data protection officer at [CONTACT EMAIL] or [CONTACT ADDRESS]</li>
          <li>Request a copy of their personal information held by TLN</li>
        </ul>

        <h2>6. Cookies and Tracking Technologies</h2>
        <p>
          TLN uses cookies and other tracking technologies to collect information about Reporters' use of the TLN website. This information may include:
        </p>
        <ul>
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Operating system</li>
          <li>Page views and navigation patterns</li>
          <li>Time spent on the website</li>
        </ul>

        <h2>7. Changes to this Privacy Policy</h2>
        <p>
          TLN reserves the right to modify or update this Privacy Policy at any time, without notice or liability. Reporters are encouraged to review this Privacy Policy regularly to stay informed about TLN's privacy practices.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact TLN's data protection officer at:
        </p>
        </p>
        <ul>
          <li>Email: [CONTACT EMAIL]</li>
          <li>Address: [CONTACT ADDRESS]</li>
          <li>Phone: [CONTACT PHONE NUMBER]</li>
        </ul>
      </section>

     
    </div>
    <Footer/>
    </div>
  );
};

export default PrivacyPolicy;
